module.exports = __webpack_public_path__ + "img/pdf.894defcc.svg";